/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentChatBatchResponse {
    getFixupPrototypeFunction() { return AgentChatBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AgentChatBatchResponse>): AgentChatBatchResponse {
        let obj = Object.assign(new AgentChatBatchResponse(), model);
        AgentChatBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentChatBatchResponse>): AgentChatBatchResponse {
        if (!model) return null;
        return AgentChatBatchResponse.newInstance(<AgentChatBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentChatBatchResponse) {
        if (!obj) return;

        models.AgentChatBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentChatBatchResponse): boolean {
        Object.setPrototypeOf(obj, AgentChatBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AgentChat.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AgentChat; };

}
